import { graphql } from '@prophecy/graphql-types/graphql';
export const DatasetDetailQuery = graphql(`
  query DatasetQuery($uid: String!) {
    Dataset(uid: $uid) {
      _id
      name
      physicalDatasets {
        _id
        name
        versionedAspects(aspectVers: [{ aspect: Configuration }]) {
          VersionedAspectName
          VersionedAspectValue
        }
      }
      project {
        _id
      }
    }
  }
`);
export const validateDatasetExpectationsQuery = graphql(`
  mutation validateExpectations(
    $uid: String!
    $entityKind: EntityKind!
    $aspectKind: AspectKind!
    $aspectValue: String!
  ) {
    validateExpectations(uid: $uid, entityKind: $entityKind, aspectKind: $aspectKind, expectations: $aspectValue) {
      success
      message
    }
  }
`);
